<template>
  <div class="contact-btn__next">
    <a
      class="contact-btn__submit--btn"
      @click.stop="handleClick"
      :class="{ active: enabled }"
      :id="stepTagId"
    >
      <span class="contact-btn--in">
        <small>利用規約と個人情報保護方針に同意して</small>無料登録を完了する
        <i class="atlas-glyphs-m-arrow-right"></i>
      </span>
    </a>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const props = defineProps({
  enabled: {
    type: Boolean,
    required: true
  }
});
const emit = defineEmits(['click']);

const route = useRoute();

const stepTagId = computed(() => {
  return `next${route.meta.order}_slide`;
});

const handleClick = () => {
  emit('click');
};
</script>
